module.exports = __webpack_public_path__ + "img/D201601_2.3e4b8146.jpg";